import React from "react";
import ReactModalWrap from "../common/ReactModalWrap";
import styles from "./Modal.module.scss";
import Button from "../common/Button";

function ConfirmationModal({
  isOpen,
  close,
  handleYes,
  header = "Are you sure that you want to delete this User?",
  subHeader = "If you delete this user he/she will lost all benefits from company account. Also you don't have options to recovery this account.",
  yesLabel = "YES",
  noLabel = "NO",
  isSubmitting = false,
}) {
  return (
    <ReactModalWrap isOpen={isOpen} close={close}>
      <div className={styles.content}>
        <div className={styles.header}>{header}</div>
        {subHeader ? <div className={styles.subHeader}>{subHeader}</div> : null}
        <div className={styles.buttonWrap}>
          <Button
            variant="white"
            className={styles.button}
            disabled={isSubmitting}
            onClick={() => handleYes()}
          >
            {yesLabel}
          </Button>
          <Button variant="white" className={styles.button} disabled={isSubmitting} onClick={() => close()}>
            {noLabel}
          </Button>
        </div>
      </div>
    </ReactModalWrap>
  );
}

export default ConfirmationModal;
